export const SET_AUTH_STATUS_MESSAGE = "SET_AUTH_STATUS_MESSAGE";
export const SET_IS_SYNCED = "SET_IS_SYNCED";

export const setAuthStatus = (data) => {
  return {
    type: SET_AUTH_STATUS_MESSAGE,
    data,
  };
};

export const setIsSynced = (isSynced) => {
  return {
    type: SET_IS_SYNCED,
    isSynced,
  };
};
